import { FormModeConfig, FormModeDefaults } from '../../../base/interfaces/formModes.ts'
import { EntradaInputProp } from '../interfaces'

export type EntradaFormMode = 'rapid' | 'create' | 'edit' | 'consult'

/**
 * Exposicion general de los modos
 */
export const entradaFormModeDefault: FormModeDefaults<EntradaFormMode> = {
  rapid: { disabled: false },
  create: { disabled: false },
  edit: { disabled: false },
  consult: { disabled: true },
}

export const entradaFormModelConfig: FormModeConfig<EntradaInputProp, EntradaFormMode> = {
  codigo: {
    rapid: { disabled: true },
    create: { disabled: true },
    edit: { disabled: true },
    consult: { disabled: true },
  },
  numeroEntrada: {
    rapid: { disabled: true },
    consult: { disabled: true },
  },
  fechaEntrega: {
    rapid: { disabled: true },
    create: { disabled: false },
    consult: { disabled: true },
  },

  fechaContable: {
    rapid: { disabled: true },
    create: { disabled: false },
    consult: { disabled: true },
  },
  fechaDocumento: {
    rapid: { disabled: true },
    create: { disabled: true },
    consult: { disabled: true },
    edit: { disabled: true },
  },
  tipoDocumento: {
    rapid: { disabled: false },
    create: { disabled: false },
    consult: { disabled: true },
  },
  proveedor: {
    rapid: { disabled: false },
    create: { disabled: false },
    consult: { disabled: true },
  },
  refDocumento: {
    rapid: { disabled: false },
    create: { disabled: false },
    consult: { disabled: true },
  },
  refNroDocumento: {
    rapid: { disabled: false },
    create: { disabled: false },
    consult: { disabled: true },
  },
  detalleExtra: {
    rapid: { disabled: false },
    create: { disabled: false },
    consult: { disabled: true },
  },
  nota: {
    rapid: { disabled: false },
    create: { disabled: false },
    consult: { disabled: true },
  },
  metodoPago: {
    rapid: { disabled: false },
    create: { disabled: true },
    consult: { disabled: true },
  },
  moneda: {
    rapid: { disabled: false },
    create: { disabled: true },
    consult: { disabled: true },
  },
  'aux.seleccionArticulo': {
    rapid: { hidden: false },
    create: { hidden: false },
    consult: { hidden: true },
  },
  detalle: {
    rapid: { disabled: false },
    create: { disabled: false },
    consult: { disabled: true },
  },
}
